import { render, staticRenderFns } from "./common-block.vue?vue&type=template&id=fb0df3a2&scoped=true"
import script from "./common-block.vue?vue&type=script&lang=js"
export * from "./common-block.vue?vue&type=script&lang=js"
import style0 from "./common-block.vue?vue&type=style&index=0&id=fb0df3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0df3a2",
  null
  
)

export default component.exports